<template>
  <div class="modal" :class="'modal--' + this.type" v-if="isOpen">
    <div class="modal__backdrop"></div>
    <div class="modal__wrapper">
      <div class="modal__container">
        <button class="modal__close" @click="close()"></button>
        <div class="modal__title" v-if="title">
          <Title size="l">{{ title }}</Title>
        </div>
        <div class="modal__content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/ui/Title.vue";
export default {
  components: { Title },

  props: {
    title: { required: false, default: false, type: [String, Boolean] },
    full: { required: false }
  },
  data() {
    return {
      isOpen: false,
      type: typeof this.full === "undefined" ? "classic" : "full"
    };
  },
  created() {},
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    }
  }
};
</script>

<style lang="scss">
.modal {
  z-index: 9999;
  @include fixed(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  &__backdrop {
    @include absolute(0, 0, 0, 0);
    background: rgba($white, 0.7);
  }
  &__wrapper {
    background: $white;
    position: relative;
    z-index: 10;
    padding: 30px;
    border-radius: $box-radius;
    box-shadow: $box-shadow;
    .modal--full & {
      @include absolute(0, 0, 0, 0);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &__close {
    width: 40px;
    height: 40px;
    background-color: $black;
    color: $white;
    border: none;
    border-radius: 100px;
    position: absolute;
    cursor: pointer;
    transition: all 0.3s;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    &::before,
    &::after {
      content: $pseudo-content;
      display: block;
      width: 60%;
      height: 1px;
      background: $white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotateZ(45deg);
      transition: all 0.3s;
    }
    &::before {
      transform: translate(-50%, -50%) rotateZ(-45deg);
    }
    &:hover {
      background-color: $white;
      box-shadow: $box-shadow-medium;
      &::before,
      &::after {
        background-color: $black;
      }
    }
  }
}
</style>
